import { C07PromoCTAProps } from './C07PromoCTA.types';
import { PromoCalloutProps } from '@ahc-digital/component-library';
import { getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getKvpValue } from 'src/shared/field-utils';

export function GetPromoCalloutModel(props?: C07PromoCTAProps): PromoCalloutProps {
  const { renderRichText, renderText, renderImage, renderLink } = useConditionalRendering();
  const { params, fields } = props || {};

  return {
    backgroundColor: getDroplink(params?.BackgroundColor, 'wellnessBlue'),
    firstCTALink: renderLink(fields?.FirstCTALink),
    firstCTAStyle: getDroplink(params?.FirstCTAStyle, 'solid'),
    headline: renderText(fields?.Headline, { required: true }),
    headlineTag: getKvpValue(fields?.TitleType, 'p'),
    image: renderImage(fields?.Image),
    imageSide: getDroplink(params?.ImageSide, 'left'),
    layout: getDroplink(params?.Layout, 'thirty'),
    secondCTALink: renderLink(fields?.SecondCTALink),
    secondCTAStyle: getDroplink(params?.SecondCTAStyle, 'solid'),
    supportingCopy: renderRichText(fields?.SupportingCopy),
    textAlignment: getDroplink(params?.TextAlignment, 'left'),
  };
}
